import React, { useEffect, useState } from 'react';
import BackRoundButton from '../../framework/forms/helpercomponents/buttons/BackRoundButton';
import { useTranslation } from '../../locale/useTranslation';
import RefreshButton from '../../framework/forms/helpercomponents/buttons/RefreshButton';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { useLocation, useNavigate } from 'react-router-dom';
import * as API_DIGI_SIGN from "../../framework/API/api_digitalSign";
import * as API from "../../framework/API/api";
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Loader } from '../../framework/forms/helpercomponents/Loader';
import { FILEURL, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import MobileGridCard from './mobileView/MobileGridCard';
import ToastNotification from '../../components/ToastNotification';

const DigitalSignReport = (props) => {

    const lang = useTranslation();
    const navigate = useNavigate();
    let customColumns = props?.customColumns ?? [];

    let wherestatement = props?.wherestatement ?? [];
    let page_take = props?.page_take ?? 100;
    let isPageable = props.isPageable ?? true;

    const location = useLocation();
    const [gridData, setGridData] = useState([]);
    const [dataColumns] = useState(customColumns ?? []);
    const [isLoading, setIsLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [total, setTotal] = useState(1);
    const [page, setPage] = useState({
        skip: 0,
        take: page_take,
    });

    let href = location.state ? location.state.href : false;
    if (href) {
        wherestatement = location.state.wherestatement;
    }

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const updateScreenType = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            setIsMobile(isPortrait);
        };
        updateScreenType();
        window.addEventListener('resize', updateScreenType);
        return () => window.removeEventListener('resize', updateScreenType);
    }, []);

    useEffect(() => {
        setIsLoading(true);
        setPage({ skip: 0, take: page_take });
        loaddata({ per_page: page_take, current_page: 1 }, wherestatement, searchText);
    }, []);

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim();
        setSearchText(text);
    };

    // Search 
    useEffect(() => {
        if (!searchText) return;
        if (searchText != "") {
            const timeOut = setTimeout(() => {
                setIsLoading(true);
                loaddata({ per_page: page.take, current_page: 1 }, wherestatement, searchText);
            }, 700);
            return () => clearTimeout(timeOut);
        } else {
            setIsLoading(true);
            setPage({ skip: 0, take: page_take });
            loaddata({ per_page: page_take, current_page: 1 }, wherestatement, searchText);
        }
    }, [searchText]);

    const loaddata = async (pagination, wherestatement, searchText) => {
        setIsLoading(true);
        let res = await API_DIGI_SIGN.getDigitalSignReport(
            {
                query: wherestatement,
                page: pagination.current_page,
                perPage: pagination.per_page,
            },
            searchText,
        );
        console.log(res);
        if (res.success) {
            // setGridData(res.data);
            setGridData(
                res.data.map((d) => ({
                    ...d,
                    screenActiveAgo: utility.timeAgo(d?.screenActiveAgo ?? 0),
                }))
            );
            setTotal(res?.pagination?.total);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setGridData([]);
        }
        setIsLoading(false);
    };


    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        await loaddata({ per_page: e.page.take, current_page: current_page }, wherestatement, searchText);
        setPage(e.page);
    };

    const refreshCollection = () => {
        loaddata({ per_page: page_take, current_page: 1 }, wherestatement, '');
    }

    const downloadExcel = async () => {

        if (gridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
            return;
        }
        let res = await API.exportGridExcel(gridData, dataColumns);
        console.log(res.data);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <h1 className="page-title txt-color-bludeDark">
                <i
                    className="fa fa-table marlr"
                    style={{ fontSize: "20px", color: "GrayText" }}
                ></i>
                <span>{lang.digital_sign_report_header}</span>
            </h1>
            {isMobile ? (
                <div className="d-flex justify-content-between align-items-center px-2  mb-4">
                    <div className="d-flex align-items-center gap-2 mr-2">
                        <BackRoundButton onClick={() => navigate(-1)} />
                        <RefreshButton onClick={refreshCollection} />
                        <RoundButton icon="download" style={{ color: "white" }} btnColor="info" title={lang.export_button_tooltip} onClick={downloadExcel} />
                    </div>
                    <div className="input-group w-auto">
                        <input
                            type="text"
                            className="form-control shadow-inset-2 pt-0 pb-0"
                            id="searchInput"
                            placeholder={lang.search_button_text}
                            onChange={onSearch}
                            onFocus={(e) => props.setOutSideFocus?.(true)}
                            onBlur={(e) => props.setOutSideFocus?.(false)}
                        />
                        <button
                            id="search"
                            className="btn btn-outline-secondary"
                            style={{ height: "38px" }}
                        >
                            <i className="fa fa-search" />
                        </button>
                    </div>
                </div>
            ) : (
                <div className="flex-container">
                    <div className="martb mar">
                        <BackRoundButton onClick={() => navigate(-1)} />
                    </div>
                    <div className="flex-container-reverse flex-item-auto">
                        <div className="input-group input-group w-300 martb" >
                            <input
                                type="text"
                                className="form-control shadow-inset-2 pt-0 pb-0"
                                id="searchInput"
                                placeholder={lang.search_button_text}
                                onChange={onSearch}
                                onFocus={(e) => props.setOutSideFocus?.(true)}
                                onBlur={(e) => props.setOutSideFocus?.(false)}
                            />
                            <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                    </span>
                                </div>
                            </button>
                        </div>
                        <div className="mt-1" style={{ paddingTop: "12px" }}>
                            <RefreshButton onClick={refreshCollection} />
                            <RoundButton
                                icon="download"
                                style={{ color: "white", marginLeft: "5px", marginRight: "5px" }}
                                btnColor="info"
                                title={lang.export_button_tooltip}
                                onClick={downloadExcel}
                            />
                        </div>
                    </div>
                </div>
            )}
            {isLoading ? <Loader /> :
                <div>
                    {isMobile ?
                        gridData.length > 0 ? gridData.map((item, index) => {
                            return (
                                <MobileGridCard
                                    key={index}
                                    title={item?.userName}
                                    label1={item?.userPhoneNo}
                                    label2={item?.screenName}
                                    description={item?.userEmail}
                                    topRight={item?.planName}
                                    bottomRight={`Plan Tenure : ${item?.planTenure}`}
                                    height="110px"
                                />
                            )
                        }) : <p className='text-center'>No Record found</p>
                        :
                        <Grid style={{ height: "76vh" }} pageable={isPageable} skip={page.skip} take={page.take} onPageChange={pageChange} total={total} resizable={true} data={gridData} >
                            <GridColumn field="userName" title="User Name" width={"auto"} />
                            <GridColumn field="userEmail" title="User Email" width={"auto"} />
                            <GridColumn field="userPhoneNo" title="User Phone No" width={"auto"} />
                            <GridColumn field="screenName" title="Screen Name" width={"auto"} />
                            <GridColumn field="planName" title="Plan Name" width={"auto"} />
                            <GridColumn field="planTenure" title="Plan Tenure" width={"auto"} />
                            <GridColumn field="planPurchaseDate" title="Plan Purchase Date" width={"auto"} />
                            <GridColumn field="planExpireDate" title="Plan Expiry Date" width={"auto"} />
                            <GridColumn field="screenActiveAgo" title="Screen Active Ago" width={"auto"} />
                        </Grid>
                    }
                </div>}
        </>
    )
};

export default DigitalSignReport;